/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type FindVolunteerByEmailQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
  event_id: Types.Scalars["Int"];
}>;

export type FindVolunteerByEmailQuery = {
  volunteer: Array<
    Pick<
      Types.Volunteer,
      "primary_category_name" | "notes" | "event_attendee_id"
    > & {
      event_attendee: {
        user: Pick<Types.User, "name" | "legal_name" | "email">;
      };
    }
  >;
};

export const FindVolunteerByEmailDocument = gql`
  query FindVolunteerByEmail($email: String!, $event_id: Int!) {
    volunteer(
      where: {
        event_attendee: {
          is: {
            user: { is: { email: { equals: $email } } }
            event: { is: { id: { equals: $event_id } } }
            role: { equals: "volunteer" }
          }
        }
      }
    ) {
      primary_category_name
      notes
      event_attendee {
        user {
          name
          legal_name
          email
        }
      }
      event_attendee_id
    }
  }
`;

/**
 * __useFindVolunteerByEmailQuery__
 *
 * To run a query within a React component, call `useFindVolunteerByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVolunteerByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVolunteerByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useFindVolunteerByEmailQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FindVolunteerByEmailQuery,
    FindVolunteerByEmailQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    FindVolunteerByEmailQuery,
    FindVolunteerByEmailQueryVariables
  >(FindVolunteerByEmailDocument, baseOptions);
}
export function useFindVolunteerByEmailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FindVolunteerByEmailQuery,
    FindVolunteerByEmailQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    FindVolunteerByEmailQuery,
    FindVolunteerByEmailQueryVariables
  >(FindVolunteerByEmailDocument, baseOptions);
}
export type FindVolunteerByEmailQueryHookResult = ReturnType<
  typeof useFindVolunteerByEmailQuery
>;
export type FindVolunteerByEmailLazyQueryHookResult = ReturnType<
  typeof useFindVolunteerByEmailLazyQuery
>;
export type FindVolunteerByEmailQueryResult = ApolloReactCommon.QueryResult<
  FindVolunteerByEmailQuery,
  FindVolunteerByEmailQueryVariables
>;
